module.exports = __webpack_public_path__ + "static/media/bannerette-azul.0d1f9bc2.jpg";